// Capa de API del ABM de modulos. Los endpoints ya existian en el BFF; lo que
// faltaba era una pantalla que los usara.
//
// Aviso importante que la UI debe respetar: `update-module` REEMPLAZA el
// arreglo `process` entero. Hay que enviar siempre la lista completa, no solo
// el proceso nuevo.

const BASE = "v1/module";

// Tope del catalogo. No se pagina: la pantalla lista todos los modulos.
const CATALOG_LIMIT = 200;

const run = async (peticion, { onSuccess, onError, onFinally } = {}, fallback) => {
  try {
    const res = await peticion();
    if (res.status >= 200 && res.status < 300) {
      if (onSuccess) onSuccess(res.data);
      return res.data;
    }
    if (onError) onError(res?.data?.message || fallback);
    return null;
  } catch (err) {
    const msg =
      err?.response?.status === 401
        ? "Tu sesión expiró. Vuelve a iniciar sesión."
        : err?.response?.data?.message || err?.message || fallback;
    if (onError) onError(msg);
    return null;
  } finally {
    if (onFinally) onFinally();
  }
};

// `list-module` responde `{ count, data: [...] }`. Se acepta tambien el arreglo
// pelado por si la ruta cambiara, para no volver a fallar en silencio: sin esta
// tolerancia, una forma inesperada se traduce en «Modulos (0)» sin ningun error
// visible, que fue exactamente como se colo este bug.
const desenvolverLista = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  return [];
};

export const moduleApi = {
  // El BFF fuerza `limit: limit || 10` en su filtro, asi que mandar el body
  // vacio truncaria el catalogo a 10 modulos de los ~22 que hay. Se pide un
  // limite alto explicito: esto es un catalogo, no una tabla paginada.
  //
  // La ruta NO devuelve un arreglo pelado, sino `{ count, data: [...] }` — la
  // misma forma que ya consume «Privilegios de Usuario». Se desenvuelve aqui,
  // en la capa de API, para que la vista reciba siempre una lista.
  list: (ctx, cb) =>
    run(
      () => ctx.authAxios.post(`${BASE}/list-module`, { limit: CATALOG_LIMIT, page: 1 }),
      {
        ...cb,
        onSuccess: (res) => cb?.onSuccess?.(desenvolverLista(res)),
      },
      "No se pudieron cargar los módulos"
    ),

  create: (ctx, body, cb) =>
    run(() => ctx.authAxios.post(`${BASE}/create-module`, body), cb, "No se pudo crear el módulo"),

  update: (ctx, body, cb) =>
    run(() => ctx.authAxios.post(`${BASE}/update-module`, body), cb, "No se pudo guardar el módulo"),
};

// `createModule` exige que el id lo genere el cliente, asi que hay que
// producir ObjectIds validos: 4 bytes de timestamp + 8 de aleatoriedad.
export const newObjectId = () => {
  const ts = Math.floor(Date.now() / 1000).toString(16).padStart(8, "0");
  const rand = Array.from({ length: 16 }, () => Math.floor(Math.random() * 16).toString(16)).join("");
  return ts + rand;
};

export const isObjectId = (v) => /^[0-9a-f]{24}$/i.test(String(v || ""));

export default moduleApi;
